import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import Loader from './Loader'

const Layout = ({ children, isLoading = false }) => {
	const [sidebarOpen, setSidebarOpen] = useState(false)

	return (
		<div className="flex h-screen overflow-hidden bg-gray-100">
			<Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

			<div className="flex w-0 flex-1 flex-col overflow-hidden">
				<Header onOpenSidebar={() => setSidebarOpen(true)} />

				<main className="relative flex-1 overflow-y-auto focus:outline-none">
					<div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 md:px-8">
						{isLoading ? (
							<div className="flex h-64 items-center justify-center">
								<Loader size="lg" />
							</div>
						) : (
							children || <Outlet />
						)}
					</div>
				</main>
			</div>
		</div>
	)
}

export default Layout
